import h from 'virtual-dom/h';

interface ExpandableCellOptions {
    // Always visible, left of the toggle
    summary?: VirtualDOM.VNode;
    // Clickable text in front of the chevron, e.g. `+3`
    toggleText: string;
    // Shown below the summary when expanded
    details: VirtualDOM.VNode[];
    isExpanded: boolean;
    onToggle: () => void;
    style?: Record<string, string>;
}

// A listview cell with a chevron toggle that shows or hides extra lines below its summary
export const renderExpandableCell = ({
    summary,
    toggleText,
    details,
    isExpanded,
    onToggle,
    style,
}: ExpandableCellOptions) => {
    const icon = h(
        'i',
        { className: `fa fa-chevron-${isExpanded ? 'up' : 'down'}` },
        [],
    );

    // `above-row-link` keeps the toggle clickable in `table-row-link` tables
    const toggle = h(
        'span',
        {
            className: 'pointer above-row-link',
            title: isExpanded ? 'Inklappen' : 'Uitklappen',
            onclick: (e: MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                onToggle();
            },
        },
        [`${toggleText} `, h('a', { style: { 'font-size': '10px' } }, [icon])],
    );

    const summaryRow = h(
        'div',
        {
            style: {
                display: 'flex',
                'flex-direction': 'row',
                gap: '8px',
                'align-items': 'center',
            },
        },
        summary ? [summary, toggle] : [toggle],
    );

    return h(
        'div',
        { style: { display: 'flex', 'flex-direction': 'column', ...style } },
        isExpanded ? [summaryRow, ...details] : [summaryRow],
    );
};
